import {
  LayoutDashboard, Building2, Factory, Users, TrendingUp, Flame, Zap, Share2,
  Table2, Target, Ruler, ShieldCheck, Scale, Coins, ClipboardList, Globe, BookOpen, FileText, Palette, BookMarked, LineChart,
} from "lucide-react";

// order approved by user: Dashboard, Entity, Facilities, Clients(consultant only), then the rest
export const NAV_ITEMS = [
  { key: "dashboard", to: "/", icon: LayoutDashboard },
  { key: "entity", to: "/entity", icon: Building2 },
  { key: "facilities", to: "/facilities", icon: Factory },
  { key: "clients", to: "/clients", icon: Users, consultantOnly: true },
  { key: "trends", to: "/trends", icon: TrendingUp },
  { key: "report", to: "/reports", icon: FileText },
  { key: "branding", to: "/branding", icon: Palette },
  { key: "scope1", to: "/scope-1", icon: Flame },
  { key: "scope2", to: "/scope-2", icon: Zap },
  { key: "scope3", to: "/scope-3", icon: Share2 },
  { key: "factors", to: "/emission-factors", icon: Table2 },
  { key: "targets", to: "/targets", icon: Target },
  { key: "intensity", to: "/intensity", icon: Ruler },
  { key: "verification", to: "/verification", icon: ShieldCheck },
  { key: "cbam", to: "/cbam", icon: Scale },
  { key: "carbonTax", to: "/carbon-tax", icon: Coins },
  { key: "esrs", to: "/esrs", icon: ClipboardList },
  { key: "gri", to: "/gri", icon: Globe },
  { key: "ifrsS1", to: "/ifrs-s1", icon: BookMarked },
  { key: "ifrsS2", to: "/ifrs-s2", icon: LineChart },
  { key: "glossary", to: "/glossary", icon: BookOpen },
];
